// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.units.RentalManagerUserPropertyFloorPlanUnitWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  EditUnitRequestDto,
  UpdateVideoForUnitDto,
  UserPropertyDetailsFloorPlanUnitDto,
  UserPropertyFloorPlanUnitCreateCompleteRequestWebDto,
  UserPropertyFloorPlanUnitCreateCompleteResponseWebDto,
} from '../..';

export const RentalManagerUserPropertyFloorPlanUnitWebApiHandler_createComplete_Path =
  '/api/web/v1/users/properties/floorPlans/units/createComplete';

/**
 * Create a unit with all fields for a floor plan
 */
export const RentalManagerUserPropertyFloorPlanUnitWebApiHandler_createComplete = (
  postData: UserPropertyFloorPlanUnitCreateCompleteRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFloorPlanUnitCreateCompleteRequestWebDto,
    UserPropertyFloorPlanUnitCreateCompleteResponseWebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFloorPlanUnitWebApiHandler_createComplete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanUnitWebApiHandler_edit_Path =
  '/api/web/v1/users/properties/floorPlans/units/edit';

/**
 * Edit a unit
 */
export const RentalManagerUserPropertyFloorPlanUnitWebApiHandler_edit = (
  postData: EditUnitRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, EditUnitRequestDto, UserPropertyDetailsFloorPlanUnitDto>(
    {
      endpoint: RentalManagerUserPropertyFloorPlanUnitWebApiHandler_edit_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanUnitWebApiHandler_videoUrl_Path =
  '/api/web/v1/users/properties/floorPlans/units/videoUrl';

/**
 * Update video URL of a unit within a property
 */
export const RentalManagerUserPropertyFloorPlanUnitWebApiHandler_videoUrl = (
  postData: UpdateVideoForUnitDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdateVideoForUnitDto, void>(
    {
      endpoint: RentalManagerUserPropertyFloorPlanUnitWebApiHandler_videoUrl_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
